import { UntypedFormControl } from '@angular/forms';

export const createTagsFormGroup = () => new UntypedFormControl();
